import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { setupPWA } from './pwa/registerSW.js';
import './styles/globals.css';
import { initTheme } from './lib/theme.js';

// Day or night before first paint (canvas theme, app-wide).
initTheme();

// Build stamp. Bumping this string forces a new content hash on the entry
// bundle, which renames the asset URL. That is the remote escape hatch when
// a deploy race has poisoned the OLD asset URL in client caches with the
// immutable header (2026-07-31): clients fetch the new URL fresh instead of
// hitting their poisoned cache entry.
window.__TRACON_BUILD__ = '2026-07-31-heal1';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker registration — no-op in dev, registers in production.
setupPWA();
